import { useRef } from "react";
import { motion, useScroll } from "framer-motion";
import { Download } from "lucide-react";
import { EXPERIENCES, RESUME } from "./data";
import { Reveal } from "./Reveal";

export function Experience() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start 0.8", "end 0.65"],
  });

  return (
    <section className="experience page-width" id="experience" data-testid="experience-section">
      <div className="section-heading">
        <div>
          <div className="section-kicker">A track record of shipping</div>
          <h2>
            Built across the stack.
            <br />
            Always close to the user.
          </h2>
        </div>
        <a className="button button-ghost" href={RESUME} target="_blank" rel="noreferrer" data-testid="experience-resume-button">
          View resume <Download size={15} />
        </a>
      </div>
      <div className="timeline" ref={ref}>
        <motion.span className="timeline-progress" style={{ scaleY: scrollYProgress }} />
        {EXPERIENCES.map((item, i) => (
          <Reveal className="timeline-item" delay={0.05} key={item.company} data-testid={`experience-item-${i}`} y={20}>
            <div className="timeline-date">{item.years}</div>
            <div className="timeline-marker">
              <span />
            </div>
            <div className="timeline-content">
              <div className="role-line">
                <h3>{item.role}</h3>
                <span>{item.company}</span>
              </div>
              <p>{item.copy}</p>
              <div className="tag-list">
                {item.tags.map((tag) => (
                  <span key={tag}>{tag}</span>
                ))}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
